import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  refresh(event) {
    if (event.target.value.trim() !== '') return;

    this.element.requestSubmit();
  }
}
